/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversation_Invalid_IdInputs */

const en_us2_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That conversation link is not valid.`)
};

const pt_br2_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse link de conversa não é válido.`)
};

const es_419_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese enlace de conversación no es válido.`)
};

const pt_pt2_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse link de conversa não é válido.`)
};

const fr_fr2_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien de conversation n'est pas valide.`)
};

const de_de2_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Link zur Unterhaltung ist ungültig.`)
};

const it_it2_conversation_invalid_id = /** @type {(inputs: Conversation_Invalid_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo link alla conversazione non è valido.`)
};

/**
* | output |
* | --- |
* | "That conversation link is not valid." |
*
* @param {Conversation_Invalid_IdInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const conversation_invalid_id = /** @type {((inputs?: Conversation_Invalid_IdInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversation_Invalid_IdInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_conversation_invalid_id(inputs)
	if (locale === "es-419") return es_419_conversation_invalid_id(inputs)
	if (locale === "pt-PT") return pt_pt2_conversation_invalid_id(inputs)
	if (locale === "fr-FR") return fr_fr2_conversation_invalid_id(inputs)
	if (locale === "de-DE") return de_de2_conversation_invalid_id(inputs)
	if (locale === "it-IT") return it_it2_conversation_invalid_id(inputs)
	return en_us2_conversation_invalid_id(inputs)
});
export { conversation_invalid_id as "conversation.invalid_id" }